module.exports = __webpack_public_path__ + "img/mind_skeleton_31.0b3bb60d.png";